module.exports = __webpack_public_path__ + "files/7ef2a5ae9eb88014a547dcaaa99dcfb2.png";